export const generativeAiAgentsCatalogs = "/generative_ai/agents/catalogs";
